import { atom } from 'recoil';

import { CashAccount } from '@shared/api/cashAccount/cashAccount.interface';

export const feventIdInMemberListEditorAtom = atom<string | undefined>({
  key: 'feventIdInMemberListEditorAtom',
  default: undefined,
});

export const cashAccountListByFeventAtom = atom<CashAccount[]>({
  key: 'cashAccountListByFeventAtom',
  default: [],
});
